import queryString from 'query-string';
import { protectedResources } from '../authConfig';
// import { getAccessToken, getStarConnectAccessToken } from './AuthConfig';
import { getToken } from './token';
type AccessToken = 'fleet-insights' | 'star-connect';

const request = async (url: string, options: any, accessToken?: AccessToken) => {
  const requestHeaders = options.headers || new Headers();
  if (!requestHeaders.has('Content-Type')) {
    requestHeaders.append('Content-Type', 'application/json');
  }

  /*let apiToken;
  if (accessToken === 'star-connect') {
    apiToken = await getStarConnectAccessToken();
  } else {
    apiToken = await getAccessToken();
  }

  if (!apiToken) {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
    return;
  }*/
  const token = await getToken(protectedResources.vass.scopes.read);
  requestHeaders.append('Authorization', `Bearer ${token}`);

  const updatedOptions = { ...options, headers: requestHeaders };

  return new Promise((resolve, reject) => {
    fetch(url, updatedOptions)
      .then((response: Response) => {
        if (!response.ok) {
          response
            .json()
            .then((json) => {
              const apiError = new Error(json.message ?? `${response.status}: ${response.statusText}`);
              (apiError as any).statusCode = response.status;
              (apiError as any).statusText = `${response.status}: ${response.statusText}`;
              (apiError as any).body = json;
              reject(apiError);
            })
            .catch(() => {
              // Catching the error in reading the bad response
              const apiError = new Error(`${response.status}: ${response.statusText}`);
              (apiError as any).statusCode = response.status;
              (apiError as any).statusText = `${response.status}: ${response.statusText}`;
              reject(apiError);
            });
        } else if (
          response.headers.has('Content-Type') &&
          (response.headers.get('Content-Type') || '').includes('application/json')
        ) {
          resolve(response.json());
        } else {
          resolve(response);
        }
        // TODO: If response is 401 -> Reauthenticate
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const requestFile = async (url: string, options: any, accessToken?: AccessToken) => {
  const requestHeaders = options.headers || new Headers();
  const token = await getToken(protectedResources.vass.scopes.read);
  requestHeaders.append('Authorization', `Bearer ${token}`);
  requestHeaders.append('Accept', 'application/json');
  const updatedOptions = { ...options, headers: requestHeaders };

  return new Promise((resolve, reject) => {
    fetch(url, updatedOptions)
      .then((response: Response) => {
        if (!response.ok) {
          response
            .json()
            .then((json) => {
              const apiError = new Error(json.message ?? `${response.status}: ${response.statusText}`);
              (apiError as any).statusCode = response.status;
              (apiError as any).statusText = `${response.status}: ${response.statusText}`;
              (apiError as any).body = json;
              reject(apiError);
            })
            .catch(() => {
              // Catching the error in reading the bad response
              const apiError = new Error(`${response.status}: ${response.statusText}`);
              (apiError as any).statusCode = response.status;
              (apiError as any).statusText = `${response.status}: ${response.statusText}`;
              reject(apiError);
            });
        } else if (
          response.headers.has('Content-Type') &&
          (response.headers.get('Content-Type') || '').includes('application/json')
        ) {
          resolve(response.json());
        } else {
          resolve(response);
        }
        // TODO: If response is 401 -> Reauthenticate
      })
      .catch((e) => {
        reject(e);
      });
  });
};

interface IOptions {
  queryParams?: any;
  accessToken?: AccessToken;
  signal?: AbortSignal;
  body?: any;
}

export const get: (url: string, options?: IOptions, data?: any) => Promise<any> = async (
  url,
  options,
  data,
) => {
  const { accessToken, queryParams, body, ...rest } = options || {};

  const getOptions = {
    method: 'GET',
    body: JSON.stringify(data),
    ...rest,
  };
  let enhancedUrl = url;
  if (queryParams) {
    enhancedUrl = enhancedUrl + `?${queryString.stringify(queryParams)}`;
  }
  return await request(enhancedUrl, getOptions, accessToken);
};

export const post: (url: string, body: any) => Promise<any> = async (url, body) => {
  const options = {
    method: 'POST',
    body: JSON.stringify(body),
  };
  return await request(url, options);
};

export const fileApiPost: (url: string, body: any) => Promise<any> = (url, body) => {
  const options = {
    method: 'POST',
    body: body,
  };
  return requestFile(url, options);
}
 
export const put: (url: string, body: any) => Promise<any> = (url, body) => {
  const options = {
    method: 'PUT',
    body: JSON.stringify(body),
  };
  return request(url, options);
};
export const deleteAPI: (url: string, options?: IOptions, data?: any) => Promise<any> = (
  url,
  options,
  data,
) => {
  const { accessToken, queryParams, body, ...rest } = options || {};

  const getOptions = {
    method: 'DELETE',
    body: JSON.stringify(data),
    ...rest,
  };
  let enhancedUrl = url;
  if (queryParams) {
    enhancedUrl = enhancedUrl + `?${queryString.stringify(queryParams)}`;
  }
  return request(enhancedUrl, getOptions, accessToken);
};
